import qs from "qs";
import { IPayeeDisbursementsBase } from "../../types/PayeeDisbursements";
import authAxios, { authHeader } from "../data";

const fetchAll = async (request: { contractId: string }) => {
  const result = await authAxios("/api/ContractDisbursements", {
    params: request,
    paramsSerializer: (params) => qs.stringify(params),
    headers: authHeader(),
  });

  return result.data;
};

const fetch = async (id: string) => {
  const result = await authAxios.get("/api/ContractDisbursements/" + id, {
    headers: authHeader(),
  });

  return result.data;
};

const remove = async (id: string) => {
  const result = await authAxios.delete("/api/ContractDisbursements/" + id, {
    headers: authHeader(),
  });

  return result.data;
};

const create = async (request: IPayeeDisbursementsBase) => {
  const result = await authAxios.post("/api/ContractDisbursements", request, {
    headers: authHeader(),
  });

  return result.data;
};

const edit = async (id: string, request: IPayeeDisbursementsBase) => {
  const result = await authAxios.put(
    "/api/ContractDisbursements/" + id,
    request,
    {
      headers: authHeader(),
    },
  );

  return result.data;
};

const PayeeDisbursementsService = {
  fetchAll,
  fetch,
  remove,
  create,
  edit,
};

export default PayeeDisbursementsService;
